import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

// Esta ruta debe coincidir con lo que registraste en router.register en urls.py
export const baseURI = 'catalogos/tipos-de-origenes-de-contratacion';

/**
 * GET Tipos de Origen de Contratación
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeOrigenesDeContratacion = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo de Origen de Contratación
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoDeOrigenDeContratacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo de Origen de Contratación
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeOrigenDeContratacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Origen de Contratación
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeOrigenDeContratacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Origen de Contratación
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTipoDeOrigenDeContratacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Tipo de Origen de Contratación
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarTipoDeOrigenDeContratacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
